<div class="overview-panel" [ngClass]="isOverviewActive ? chooseShowClass() : ''">
    @if(currentFocus && currentRelationFocus){
        @if (currentFocus.getShape().length > 0) {

            @if(currentFocus.getShape()[0].simulationAverage){
                <div class="d-flex justify-content-between align-items-center">
                    <h4 class="fw-4">{{SIMULATION_INFO}}</h4>
                    <button mat-button (click)="close()">{{CLOSE}}</button>
                </div>
                @for (metric of getSImulationItems(currentFocus.getShape()[0]); track $index) {
                    <div class="row table-like">
                        <span class="col-5 text-break">{{normalizeSimulationLabels(metric.name) | titlecase}}</span>
                        <div class="col-7 d-flex align-items-center pe-0">
                            <span class="text-break flex-grow-1">{{metric.value | json}}</span>
                        </div>
                    </div>
                }
                <hr>
            }

            @if(currentFocus.getShape()[0].metrics){
                <div class="d-flex justify-content-between align-items-center">
                    <h4 class="fw-4">{{METRICS}}</h4>
                    <button mat-button (click)="close()">{{CLOSE}}</button>
                </div>
                @for (metric of getMetricsItems(currentFocus.getShape()[0]); track $index) {
                    <div class="row table-like">
                        <span class="col-3 text-break">{{metric.name}}</span>
                        <div class="col-9 d-flex align-items-center pe-0">
                            <span class="text-break flex-grow-1">{{metric.value}}</span>
                        </div>
                    </div>
                }
                <hr>
            }
        
            
            
            @if(component.IsViewEditable() && this.currentFocus.getShape()[0].dbData){
                <h5 class="m-0 p-0 mt-2">Color Options</h5>
                <div class="color-shape color-container justify-content-start align-items-center">
                    @for (color of theme_colors; track $index) {
                        <div class="color" [ngStyle]="{'background-color': color.color, 'border': '2px solid'+color.theme.strokeColor}" (click)="changeTheme(color.theme)" [matTooltip]="color.name"></div>
                    }
                </div>
        
                <h5 class="m-0 p-0 mt-2">Shape Options</h5>
                <div class="color-shape shapes-menu justify-content-center align-items-center">
                    @for (shape of databaseShapes; track $index) {
                        <img [src]="shape.asset" class="shape-icon" alt="icon" (click)="selectFormChange(shape)">
                    }
                </div>
        
                <!-- <h5 class="m-0 p-0 mt-2">Choose Afected Nodes</h5>
                <mat-form-field class="col-12">
                    <mat-select [value]="AFFECT_NODE_JSON[2].value" (selectionChange)="onSelectChange($event)">
                        @for (item of AFFECT_NODE_JSON; track item) {
                            <mat-option [value]="item.value">{{item.name}}</mat-option>
                        }
                    </mat-select>
                </mat-form-field> -->
            }

            @if(isNeo4jEditor && this.currentFocus.getShape()[0].dbData){
                <h5 class="m-0 p-0 mt-2">Icon Options</h5>
                <div class="color-shape shapes-menu justify-content-center align-items-center">
                    @for (icon of databaseIcons; track $index) {
                        @let parsed = parseIconData(icon.image);
                        <svg 
                            xmlns="http://www.w3.org/2000/svg" 
                            width="30" 
                            height="30"
                            [attr.viewBox]="'0, 0 '+ parsed.width+' '+parsed.height" fill="none" stroke="none"
                            (click)="selectedIcon(icon.__EDT_UUID__)"
                        >
                            @for (data of parsed.icon; track $index) {
                                @if(data.type === "fill"){
                                    <path [attr.d]="data.path" fill="white"/>
                                }@else{
                                    <path [attr.d]="data.path" stroke="white"/>
                                }
                            }
                        </svg>
                    }
                </div>
            }

            @if(currentFocus.getShape()[0].hyperFlows){
                <div class="d-flex justify-content-between align-items-center">
                    <h4 class="fw-4">{{HYPERFLOWS}}</h4>
                    <button mat-button (click)="close()">{{CLOSE}}</button>
                </div>

                <properties-hyperflows [hyperflows]="currentFocus.getShape()[0].hyperFlows"></properties-hyperflows>
                <hr>
            }
            
            <br>
            <div class="d-flex justify-content-center align-items-center">
                <button mat-raised-button (click)="onTakeScreenshot()">Take Screenshot of Container</button>
            </div>
            <br>

            <div class="d-flex justify-content-between align-items-center">
                <h4 class="fw-4">{{NODE_PROPERTIES}}</h4>
                <button mat-button (click)="close()">{{CLOSE}}</button>
            </div>
            
            @if(this.currentFocus.getShape().length === 1){
                @if (this.currentFocus.getShape()[0].dbData) {
                    <mat-chip-set>
                        @for (label of currentFocus.getShape()[0].getAllLabels(); track $index) {
                        <mat-chip color="primary" selected>
                            {{label}}
                        </mat-chip>
                        }
                    </mat-chip-set>
                    <br>

                    <properties-table 
                        [properties]="currentFocus.getShape()[0].fields" 
                        [showOptions]="component.IsViewEditable()" 
                        (onEvent)="onGenericPropsTable($event, nodeMenuTrigger)">
                    </properties-table>
                    <mat-menu #NodeProps="matMenu">
                        <button mat-menu-item (click)="onNodePropsEdit()">Edit</button>
                        <button mat-menu-item>Delete</button>
                    </mat-menu>
                    <button mat-button [matMenuTriggerFor]="NodeProps" #nodeMenuTrigger="matMenuTrigger" style="display: none;"></button>
                }@else{
                    <h5>{{NODE_DOES_NOT_EXISTS}}</h5>
                    @if(component.IsViewEditable()){
                        <div class="d-flex justify-content-center align-items-center">
                            <button mat-raised-button (click)="deleteContainerFromView()">DELETE FROM VIEW</button>
                        </div>
                    }
                }
            }
    
            @if(isNeo4jEditor){
                @if(this.currentFocus.getShape()[0].dbData){
                    @if (!addProperty) {
                        <div class="row justify-content-end">
                            <button class="add_properties_button" (click)="onAddProperty(true)"><mat-icon>add</mat-icon></button>
                        </div>
                    }@else {
                        <div class="row table-like justify-content-center">
                            <input matInput placeholder="name" [(ngModel)]="propertyName" class="col-3 me-2"/>
                            <input matInput placeholder="value" [(ngModel)]="propertyValue"  class="col-6 text-break"/>
                            <button class="properties_button ms-2" (click)="onAddProperty(false)"><mat-icon>close</mat-icon></button>
                            <button class="properties_button ms-2" (click)="addPropertyToNode()"><mat-icon>done</mat-icon></button>
                        </div>
                    }
                }
                <br>
                @if(currentFocus.getShape().length > 0 && this.currentFocus.getShape()[0].dbData){

                    <div class="d-flex justify-content-between align-items-center">
                        <h4 class="fw-4">{{SHAPE_PROPERTIES}}</h4>
                        <button mat-button (click)="close()">{{CLOSE}}</button>
                    </div>
                    <properties-table 
                        [properties]="getShapeFields(currentFocus.getShape()[0])" 
                        [showOptions]="component.IsViewEditable()" 
                        (onEvent)="onGenericPropsTable($event, shapeMenuTrigger)">
                    </properties-table>

                    <mat-menu #ShapeProps="matMenu">
                        <button mat-menu-item (click)="onShapePropsEdit()">Edit</button>
                    </mat-menu>
                    <button mat-button [matMenuTriggerFor]="ShapeProps" #shapeMenuTrigger="matMenuTrigger" style="display: none;"></button>
                }
                @if(this.currentFocus.getShape()[0].dbData){
                    @if (!changeLytProperty) {
                        <div class="row justify-content-end">
                            <button class="add_properties_button" (click)="onChangeLytProperty(true)"><mat-icon>add</mat-icon></button>
                        </div>
                    }@else {
                        <div class="row table-like justify-content-center">
                            <input matInput placeholder="name" [(ngModel)]="lytPName" class="col-3 me-2"/>
                            <input matInput placeholder="value" [(ngModel)]="lytPValue"  class="col-6 text-break"/>
                            <button class="properties_button ms-2" (click)="onChangeLytProperty(false)"><mat-icon>close</mat-icon></button>
                            <button class="properties_button ms-2" (click)="changeLYTProperty()"><mat-icon>done</mat-icon></button>
                        </div>
                    }
                }
            }

            <br class="mt-3">
            
        }@else if(currentRelationFocus.getConnection()){
            <!-- <h4 class="fw-4">{{RELATION_PROPERTIES}}</h4> -->
            <div class="d-flex justify-content-between align-items-center">
                <h4 class="fw-4">{{RELATION_PROPERTIES}}</h4>
                <button mat-button (click)="close()">{{CLOSE}}</button>
            </div>
            
    
            @if(component.IsViewEditable()){
                <h5 class="m-0 p-0 mt-2">Arrow Style</h5>
                <div class="color-shape arrow-container justify-content-center align-items-center">
                    <div class="arrow-click" (click)="changeArrow('SOLID')">
                        <div class="arrow solid" [ngClass]="{'selected': getConnArrowStyle() === 'SOLID'}"></div>
                    </div>
                    <div class="arrow-click" (click)="changeArrow('DASHED')">
                        <div class="arrow dashed" [ngClass]="{'selected': getConnArrowStyle() === 'DASHED'}"></div>
                    </div>
                    <div class="arrow-click" (click)="changeArrow('DOTTED')">
                        <div class="arrow dotted" [ngClass]="{'selected': getConnArrowStyle() === 'DOTTED'}"></div>
                    </div>
                </div>

                <h5 class="m-0 p-0 mt-2">Arrow Type</h5>
                <div class="color-shape arrow-container justify-content-center align-items-center">
                    <div class="arrow-click" (click)="selectType('DIRECT', $event)">
                        <div class="arrow solid" [ngClass]="{'selected': getConnType() === 'DIRECT'}"></div>
                    </div>
                    <div 
                        class="square-arrow-container d-flex justify-content-center align-items-center mb-2"
                        style="margin-top:5px;"
                        (click)="selectType('SQUARED', $event)"
                    >
                        <svg width="120" height="50" viewBox="0 0 120 50">
                            <polyline 
                            points="0,37 60,37 60,22 110,22" 
                            fill="none" 
                            [attr.stroke]="getConnType() === 'SQUARED' ? 'orange' : '#000000'"
                            stroke-width="2" 
                            stroke-linecap="round" 
                            stroke-linejoin="round"
                            />
                            <polygon 
                            points="120,22 110,17 110,27"
                            [attr.fill]="getConnType() === 'SQUARED' ? 'orange' : '#000000'"
                            />
                        </svg>
                    </div>
                    <div 
                        class="square-arrow-container d-flex justify-content-center align-items-center mb-2"
                        style="margin-top:5px;"
                        (click)="selectType('L_SHAPED', $event)"
                    >
                        <svg width="120" height="50" viewBox="0 0 120 50">
                            <polyline 
                            points="0,37 110,37 110,22" 
                            fill="none" 
                            [attr.stroke]="getConnType() === 'L_SHAPED' ? 'orange' : '#000000'"
                            stroke-width="2" 
                            stroke-linecap="round" 
                            stroke-linejoin="round"
                            />
                            <polygon 
                            points="110,12 105,22 115,22"
                            [attr.fill]="getConnType() === 'L_SHAPED' ? 'orange' : '#000000'"
                            />
                        </svg>
                    </div>
                </div>

                @if (isCurrentConnTypeOrthogonal()) {
                    <h5 class="m-0 p-0 mt-2">Anchor Options</h5>
                    <div class="color-shape arrow-container justify-content-center align-items-center mb-4">
                        <div class="anchor-rectangles mb-2">
                            <div class="anchor-rectangle">
                                <span
                                    class="rect-label"
                                    [ngClass]="{'selected': getConnAnchor().from === 'any'}"
                                    (click)="selectAnchor('from', 'any', $event)"
                                >From</span>
                                <div 
                                    class="anchor-point top" 
                                    [ngClass]="{'selected': getConnAnchor().from === 'top'}"
                                    (click)="selectAnchor('from', 'top', $event)">
                                </div>
                                <div 
                                    class="anchor-point right" 
                                    [ngClass]="{'selected': getConnAnchor().from === 'right'}"
                                    (click)="selectAnchor('from', 'right', $event)">
                                </div>
                                <div 
                                    class="anchor-point bottom" 
                                    [ngClass]="{'selected': getConnAnchor().from === 'bottom'}"
                                    (click)="selectAnchor('from', 'bottom', $event)">
                                </div>
                                <div 
                                    class="anchor-point left" 
                                    [ngClass]="{'selected': getConnAnchor().from === 'left'}"
                                    (click)="selectAnchor('from', 'left', $event)">
                                </div>
                            </div>
                            <div class="anchor-rectangle">
                                <span 
                                    class="rect-label"
                                    [ngClass]="{'selected': getConnAnchor().to === 'any'}"
                                    (click)="selectAnchor('to', 'any', $event)"
                                >to</span>
                                <div 
                                    class="anchor-point top" 
                                    [ngClass]="{'selected': getConnAnchor().to === 'top'}"
                                    (click)="selectAnchor('to', 'top', $event)">
                                </div>
                                <div 
                                    class="anchor-point right" 
                                    [ngClass]="{'selected': getConnAnchor().to === 'right'}"
                                    (click)="selectAnchor('to', 'right', $event)">
                                </div>
                                <div 
                                    class="anchor-point bottom" 
                                    [ngClass]="{'selected': getConnAnchor().to === 'bottom'}"
                                    (click)="selectAnchor('to', 'bottom', $event)">
                                </div>
                                <div 
                                    class="anchor-point left" 
                                    [ngClass]="{'selected': getConnAnchor().to === 'left'}"
                                    (click)="selectAnchor('to', 'left', $event)">
                                </div>
                            </div>
                        </div>
                    </div>
                }

                @if (isCurrentConnTypeLShaped()) {
                    <h5 class="m-0 p-0 mt-2">L Arrow Spacing</h5>
                    <div class="mb-4 px-2">
                        <label class="form-label mb-1">Horizontal</label>
                        <div class="d-flex align-items-center gap-3">
                            <input
                                type="range"
                                min="-400"
                                max="400"
                                step="4"
                                class="form-range flex-grow-1"
                                [ngModel]="getConnLArrowHorizontalSpacing()"
                                (ngModelChange)="changeLArrowHorizontalSpacing($event)"
                            />
                            <input
                                type="number"
                                min="-400"
                                step="4"
                                class="form-control"
                                style="max-width: 90px;"
                                [ngModel]="getConnLArrowHorizontalSpacing()"
                                (ngModelChange)="changeLArrowHorizontalSpacing($event)"
                            />
                        </div>
                        <label class="form-label mb-1 mt-3">Vertical</label>
                        <div class="d-flex align-items-center gap-3">
                            <input
                                type="range"
                                min="-400"
                                max="400"
                                step="4"
                                class="form-range flex-grow-1"
                                [ngModel]="getConnLArrowVerticalSpacing()"
                                (ngModelChange)="changeLArrowVerticalSpacing($event)"
                            />
                            <input
                                type="number"
                                min="-400"
                                step="4"
                                class="form-control"
                                style="max-width: 90px;"
                                [ngModel]="getConnLArrowVerticalSpacing()"
                                (ngModelChange)="changeLArrowVerticalSpacing($event)"
                            />
                        </div>
                    </div>
                }

                <h5 class="m-0 p-0 mt-2">Text Position</h5>
                <div class="mb-4 px-2">
                    <label class="form-label mb-1">0 = Start, 100 = End</label>
                    <div class="d-flex align-items-center gap-3">
                        <input
                            type="range"
                            min="0"
                            max="100"
                            step="1"
                            class="form-range flex-grow-1"
                            [ngModel]="getConnTextPositionPercent()"
                            (ngModelChange)="changeConnTextPositionPercent($event)"
                        />
                        <input
                            type="number"
                            min="0"
                            max="100"
                            step="1"
                            class="form-control"
                            style="max-width: 90px;"
                            [ngModel]="getConnTextPositionPercent()"
                            (ngModelChange)="changeConnTextPositionPercent($event)"
                        />
                    </div>
                </div>
            }
    
            @if (currentRelationFocus.getConnection()) {
                @if(currentRelationFocus.getConnection()!.relation){
                    <properties-table 
                        [properties]="currentRelationFocus.getConnection()!.fields" 
                        [showOptions]="component.IsViewEditable()" 
                        (onEvent)="onGenericPropsTable($event, relMenuTrigger)">
                    </properties-table>
                    <mat-menu #RelProps="matMenu">
                        <button mat-menu-item (click)="onNodePropsEdit()">Edit</button>
                        <button mat-menu-item>Delete</button>
                    </mat-menu>
                    <button mat-button [matMenuTriggerFor]="RelProps" #relMenuTrigger="matMenuTrigger" style="display: none;"></button>

                    @if(isNeo4jEditor){
                        @if (!addProperty) {
                            <div class="row justify-content-end">
                                <button class="add_properties_button" (click)="onAddProperty(true)"><mat-icon>add</mat-icon></button>
                            </div>
                        }@else {
                            <div class="row table-like justify-content-center">
                                <input matInput placeholder="name" [(ngModel)]="propertyName" class="col-3 me-2"/>
                                <input matInput placeholder="value" [(ngModel)]="propertyValue"  class="col-6 text-break"/>
                                <button class="properties_button ms-2" (click)="onAddProperty(false)"><mat-icon>close</mat-icon></button>
                                <button class="properties_button ms-2" (click)="addPropertyToRelationship()"><mat-icon>done</mat-icon></button>
                            </div>
                        }
                    }
                }@else{
                    @if (component.IsViewEditable()) {
                        <h5>{{RELATION_DOES_NOT_EXISTS}}</h5>
                        <div class="d-flex justify-content-center align-items-center">
                            <button mat-raised-button (click)="deleteRelationFromView()">DELETE FROM VIEW</button>
                        </div>
                    }
                }
            }
    
        }@else{
            @if (neo4jConnection) {
                <!-- <h4 class="fw-4">{{OVERVIEW}}</h4> -->
                <div class="d-flex justify-content-between align-items-center">
                    <h4 class="fw-4">{{OVERVIEW}}</h4>
                    <button mat-button (click)="close()">{{CLOSE}}</button>
                </div>
                <div class="row table-like">
                    <span class="col-3 me-2">{{DATA_SERVICE}}</span>
                    <span class="col-8 text-break">{{neo4jConnection.connection.dataService.data_service_name}}</span>
                </div>
                <!-- @if(hierarchy){
                    <div class="row table-like">
                        <span class="col-3 me-2">{{CONTAINER_HIERARCHY}}</span>
                        <span class="col-8 text-break code-container">
                            <pre>{{hierarchy}}</pre>
                        </span>
                    </div>
                } -->
                @if (component) {
                    <h5 class="mt-2 mb-0">{{CYPHER}}</h5>
                    <hr class="m-2">
                    @for (sentence of component.getCurrentSentence(); track $index) {
                        <div class="position-relative mb-2">
                            <pre class="text-break code-container mb-0 pe-5"><code>{{sentence}}</code></pre>
                            <button
                                class="position-absolute top-0 end-0 m-1"
                                mat-icon-button
                                [cdkCopyToClipboard]="sentence"
                                matTooltip="Copy complete content"
                                aria-label="Copy complete content">
                                <mat-icon>content_copy</mat-icon>
                            </button>
                        </div>
                    }
                }
                @if (dbLabels) {
                    <h5 class="mt-2 mb-0">{{NODE_LABELS}}</h5>
                    <hr class="m-2">
                    <mat-chip-set>
                        @for (label of dbLabels; track $index) {
                        <mat-chip color="primary" selected>
                            {{label}}
                        </mat-chip>
                        }
                    </mat-chip-set>
                }
                @if (dbRelations) {
                    <h5 class="mt-2 mb-0">{{RELATIONSHIP_TYPES}}</h5>
                    <hr class="m-2">
                    <mat-chip-set>
                        @for (relation of dbRelations; track $index) {
                        <mat-chip class="m-2" color="primary" selected>
                            {{relation}}
                        </mat-chip>
                        }
                    </mat-chip-set>
                }
            }
        }
    }
</div>

